import React, { useState, useEffect } from 'react';
import ErrorWrapper from '@/app/ErrorWrapper';
import { Link } from 'react-router-dom';
import 'react-datepicker/dist/react-datepicker.css';
import { List as ListAntd } from 'antd';
import { coursesApi } from '@/api/courses/coursesApi';
import { routesPath } from '@/utils/routesPath';
import { convertRoutePathToLink } from '@/utils/functions';
import { useSelector, useDispatch } from 'react-redux';
import { getProfile } from '@/pages/Users/store/profileThunk';
import { useTranslation } from 'react-i18next';

const URL = convertRoutePathToLink(routesPath.COURSES_STUDENT);

const ListComponent = ({ ...props }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.profile);
    const authData = useSelector((state) => state.auth);
    const [data, setData] = useState([]);
    const [isLoadingData, setIsLoadingData] = useState(true);
    const tokens = user?.tokens || [];

    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 12,
        total: 0
    });

    const getList = () => {
        let filter = {};
        if (authData?.roles[0]?.name === 'Teacher') {
            filter = {
                teacherId: user?.id
            };
        }

        coursesApi
            .getList({
                page: pagination.page,
                pageSize: pagination.pageSize,
                filter: JSON.stringify(filter)
            })
            .then((res) => {
                setIsLoadingData(false);
                setData(res.data.data.rows);
                setPagination({ ...pagination, total: res.data.data.total });
            })
            .catch((err) => console.error(err));
    };

    useEffect(() => {
        getList();
    }, [pagination.page]);

    useEffect(() => {
        if (authData?.roles[0].name == 'Student') {
            dispatch(getProfile({ ...user, roles: authData?.roles }));
        }
    }, []);

    return (
        <>
            <div className="section-body">
                <div className="container-fluid">
                    <div className="d-flex justify-content-between align-items-center ">
                        <div className="header-action">
                            <h1 className="page-title">{t('Course_Student_List_Title')}</h1>
                            <ol className="breadcrumb page-breadcrumb">
                                <li className="breadcrumb-item">
                                    <a href>{t('Course_Student_List_BrandName')}</a>
                                </li>
                                <li
                                    className="breadcrumb-item active"
                                    aria-current="page">
                                    {t('Course_Student_List_Title')}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-body mt-4">
                <div className="container-fluid">
                    {authData?.roles[0].name == 'Student' && (
                        <div className="flex">
                            {tokens?.map((item, idx) => (
                                <div
                                    className="col-lg-3 col-md-6"
                                    key={idx}>
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="widgets1">
                                                <div className="icon">
                                                    <i className="icon-trophy text-success font-30"></i>
                                                </div>
                                                <div className="details">
                                                    <h6 className="mb-0 font600">
                                                        {t(item?.tokenType?.name)}
                                                    </h6>
                                                    <span className="mb-0">
                                                        {t('Course_Student_List_Credit')}:{' '}
                                                        {item?.credit}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="row row-deck">
                        <ListAntd
                            className="w-full"
                            grid={{
                                gutter: 16,
                                xs: 1,
                                sm: 2,
                                md: 4,
                                lg: 4,
                                xl: 6,
                                xxl: 4
                            }}
                            loading={isLoadingData}
                            pagination={{
                                pageSize: pagination.pageSize,
                                current: pagination.page,
                                total: pagination.total,
                                onChange: (e) => setPagination({ ...pagination, page: e })
                            }}
                            dataSource={data}
                            renderItem={(item) => (
                                <ListAntd.Item className="h-full">
                                    <Link to={URL + '/edit?id=' + item?.id}>
                                        <div
                                            className="w-full h-full block"
                                            style={{ cursor: 'pointer' }}>
                                            <div className="card ribbon h-full flex flex-col">
                                                <div className="ribbon-box orange">
                                                    <i className="fa fa-star"></i>
                                                </div>
                                                <a href>
                                                    <img
                                                        className="card-img-top object-cover h-40"
                                                        src={
                                                            item?.thumbnail
                                                                ? item?.thumbnail
                                                                : '../assets/images/gallery/2.jpg'
                                                        }
                                                        alt={t(
                                                            'Course_Student_List_CourseImageAlt'
                                                        )}
                                                    />
                                                </a>
                                                <div className="card-body d-flex flex-column flex-grow">
                                                    <h5>{item.title}</h5>
                                                    <div className="text-muted">
                                                        {item.description}
                                                    </div>
                                                </div>
                                                <div className="table-responsive">
                                                    <table className="table table-striped table-vcenter mb-0">
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <i className="fa fa-shopping-cart text-danger"></i>
                                                                </td>
                                                                <td className="tx-medium">
                                                                    {t(item?.tokenType?.name)}
                                                                </td>
                                                                <td className="text-right">
                                                                    {item.tokenCost}
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </ListAntd.Item>
                            )}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

ListComponent.displayName = 'List';

const List = (props) => {
    return (
        <ErrorWrapper>
            <ListComponent
                data-id="List-cpn"
                {...props}
            />
        </ErrorWrapper>
    );
};

export default List;
